module.exports = __webpack_public_path__ + "static/media/AutoCAD MEP.8c33ac73.png";